<template>

    <div class="column col-12 col-mx-auto">
                        


        <div class="wrap">
            
        
            <h3 class="entry-title" > <i class="fas fa-check"></i> Dziękujemy za cierpliwość, <br> z radością możemy zaproponować Ci kwotę: </h3>  


            <h1 class="offered text-center" v-dynamic="formatedAmount"></h1>



            <div class="d-flex justify-content-center">


                <div class="col-lg-4 mb-5 order-2 order-lg-2">         



    <div id="calc-app" class="wrapper calc proposal" data-app>

              <vue-slider class=""
                  dotSize="50"
                  v-model="loanAmount"
                  :tick-labels="sliderLabels"
                  :min="minAmount"
                  :max="maxAmount"
                  :interval="step"
                  ticks="always"
                  tick-size="4"
                  :tooltip="'none'"
                  @change="onChange"
                  :process="false"
                  :height="3"
                >
                <template v-slot:dot>
                  <div class="vue-slider-dot-amount"></div>                            
                </template>                   

              </vue-slider>
    </div>



                     <div class="proposal-details side-col sticky">
                      

                      <div class="container">
                        <div class="row ">
                          <div class="col-sm-12 loan-details py-4 px-4">
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Kwota:
                                      </div>
                                      <div class="col col-auto">
                                        {{loanAmount}} zł
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Okres:
                                      </div>
                                      <div class="col col-auto">
                                        30 dni
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Data spłaty:
                                      </div>
                                      <div class="col col-auto">
                                        {{finishDate}}
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Prowizja:
                                      </div>
                                      <div class="col col-auto">
                                        {{commission}} zł
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          Oprocentowanie:
                                      </div>
                                      <div class="col col-auto">
                                        {{interest}} zł
                                      </div>
                                </div>
                                <div class="row">
                                      <div class="col col-auto me-auto">
                                          RRSO:
                                      </div>
                                      <div class="col col-auto">
                                        {{rrso}} %
                                      </div>
                                </div>
                                <div class="row summary">
                                  <div class="col col-auto me-auto">
                                      Razem:
                                  </div>
                                  <div class="col col-auto">
                                    {{total}} zł
                                  </div>
                            </div>                          
                          </div>
                        </div>  

                        <div class="text-center"><a class="plain" href="#" @click="openModal">Formularz informacyjny</a></div>                
                      </div>               
                    
                  </div> 
              
              </div>
            </div>
    


        </div>


        <div class="text-center mt-5 mb-5">

            <a key="btn-prev"  class="button btn-prev btn btn-outline-primary btn-lg me-2" @click="resign" ><i class="icon flaticon-left-arrow"></i> REZYGNUJĘ </a>            


            <a  key="btn-next"  class="button btn-next btn btn-primary btn-lg me-2" @click="accept" > DALEJ <i class="icon flaticon-right-arrow"></i></a>

                          
        </div>


        <!-- Modal -->
        <div  class="modal fade" ref="modal" >
          <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header container dark-bg">
                <div class="col-auto me-auto ">
                  <h3>Formularz Informacyjny</h3>
                </div>
                  <button type="button" class="btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" v-dynamic="details">
            
                </div>

                <div class="modal-footer justify-content-center">

                  <button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal"> Zamknij </button>
                </div>

              </div>
          </div>
        </div>
        
    </div>

</template>

<script>


  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/default.css';

    export default {
     
       name: 'FingoProposalView',


       components: {

          VueSlider
        },



       data(){

            return {

              modal: null,

              details: '',

              minAmount: 500,
              maxAmount: 500,
              step: 100,
              labelValues: [500, 500],
              sliderLabels: [],

              waitCount: 0
              
            }
       },


       computed: {


        formatedAmount(){

          return this.formatCurrency(this.loanAmount) + ' zł';
        }
         


       },


       methods: {

/*        setValues(v){


        },*/


        onChange(v) {


          this.setValues(v);
        },


        accept(){


            var page = this.$root.mainpage;


            page.isLoading = ['Przygotowujemy Twoją umowę...', 'To może potrwać do 2 minut...', 'Generujemy dokumenty...', 'Już prawie gotowe...'];
            this.waitCount = 0;


           // this.post( '/score')
            this.post( '/counteroffer', {amount: this.loanAmount})
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                  this.onWaiting();              

                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });



        },

        resign(){



            this.post( '/resign' )
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                    this.$router.push({path: 'resign'});
                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });



        },



        gotomain(){

            this.$router.push({path: '/'});
        },




        onWaiting( endpoint='application' ) {


          var page = this.$root.mainpage,
              step,


            poll = () => {

              if (this.waitCount > 60){

                page.isLoading =false;
                return;
              }

              this.waitCount++;


              this.get( '/' + endpoint )
                  .then(response => {
                   

                    if (!!response.data) {

                      step = response.data.hasOwnProperty('step') ? response.data.step : '';

    //console.log(step);

                      switch (step) {

                        case 'counteroffer':
                        case 'wait':
                          break;


                        case 'amodit':
                              page.isLoading=false;

                              let url = response.data.step_details.split('/');

                              window.location = this.getConf('amoditSignUrl') + url[ url.length - 2 ] + '%2F' + url[ url.length - 1 ];
                              return;


                                                          
                        default:
                          page.isLoading =false;
                          this.$router.push({path: 'thankyou'});
                          return;
                      }


    //console.log(response.data)

                   
                    }
                    else {
                      console.log('status empty body');
                    }


                    // dispatch another poll request
                    page.isLoading
                      && setTimeout(poll, 3000);                



                  })
                  .catch(error => {
                   
                      // wait for timeout
                      //page.isLoading = false;
                      setTimeout(poll, 3000);

         
                      // Error 
                      if (error.response) {
                     

                      } else if (error.request) {
                        
                      } else {
                          // Something happened in setting up the request and triggered an Error
                          //console.log('Error', error.message);
                      }
                  });


            };


            // initial polling
            setTimeout(poll, 3000);
        },




        openModal(v){


         /* let tmp, rg;

          if (this.detailed.match(/^__/)){


            this.detailed.split(',').map(p => {

              tmp = p.split(':');

              if (tmp.length > 1) {

                rg = new RegExp('^'+tmp[1]);

                rg.test(v) && (this.details = this.getModalContent( tmp[0].replace(/__(.*)/, '$1') ));

              }
              else {

                this.details = this.getModalContent( tmp[0].replace(/__(.*)/, '$1') );
              }

            });
          }*/

          this.details = this.getModalContent('info_form');


          this.modal.show();



         // alert(v)
        }




       },


       created() {


          // init max value
          this.maxAmount = this.loanAmount;
          this.labelValues = [500, this.loanAmount];


/*          this.sliderLabels = this.labelValues.reduce((accu, itm) => {

            if (!accu){
              return [itm];
            }

            return accu.concat( ...Array( (Math.abs(accu[accu.length-1] - itm) / this.step) - 1 ) ).concat( itm );
          }, 0);
*/

//console.log(this)



/*           bus.$on('proposal_amount', (data) => {

                //this.amount = amount;

              this.setValues(data.net_amount);         


              this.finishDate = data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');
    
           });*/



       },


    mounted(){



      this.modal = new bootstrap.Modal(this.$refs['modal']);


      // scroll to top
      this.pageTop();

    }



        
    }
</script>

<style scoped>


h3 i {
    color: #0bc268;
}

h1.offered {

    font-size: 3.5rem;
}


div.proposal-details {

  border-radius:1rem;
  background-color: #fff;
  box-shadow: 0px 12px 30px #0000001a;
  margin-top:2rem;
  padding-bottom:1rem
}


.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}


.form-btn-wrap {

  margin-top: .5rem;
  padding: 2rem 1rem;

  display: flex;
  justify-content:center;
}





.fade-enter-active,.fade-leave-active {
  transition: opacity 3s
}
.fade-enter,.fade-leave-active {
  opacity: 0
}


.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,.slide-fade-leave-active {
  padding-left: 10px;
  opacity: 0;
}



  .modal-dialog {
    max-width: 900px;
  
  }


  .modal-header{
    
    display:flex;

  }

  .modal-title {
    color: #fefefe;
  }

  .modal-body {
    overflow-y: auto;
  }



#calc-app .amount-slider .v-slider--horizontal .v-slider__tick .v-slider__tick-label {


  color: #000;
}





.button.btn-next, .button.btn-submit, .button.btn-next.disabled {

  min-width: 9rem;
}












</style>


// WEBPACK FOOTER //
// src/FingoProposalView.vue